import { render } from "./Authorization.vue?vue&type=template&id=6b007e58&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import "./Authorization.vue?vue&type=style&index=0&id=6b007e58&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b007e58"]])

export default __exports__